import { useEffect, useState } from "react";
import Input from "../Form/Input";
import RadiosLabel from "../Form/RadiosLabel";
import Button from "../Form/Button";
import ImageUploadPreview from "../Form/ImageUploadPreview";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { addProductIngredient, editProductIngredient } from "../../helpers/api_helper";

const AddDiets = ({ query, modalClose, details, isFetching }) => {
  const queryClient = useQueryClient();
  const [publishedData, setPublishedData] = useState([
    { _id: 1, label: "Published", inputName: "publish_status", current: true },
    { _id: 2, label: "Draft", inputName: "publish_status", current: false },
  ]);
  const [status, setStatus] = useState(1)
  const [title, setTitle] = useState("");
  const [uploadData, setUploadData] = useState([]);

  const { mutate: handleSubmit } = useMutation(
    (payload) => addProductIngredient(payload),
    {
      onSuccess: (res) => {
        console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(query);
          queryClient.removeQueries({
            queryKey: ["diets"],
            type: "inactive",
          });
          setTitle("");
          setUploadData([]);
          setStatus(1);
          modalClose();
        }
        if (res.status === 400) {
          toast.error(res.message);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );

  const { mutate: handleEdit } = useMutation(
    (payload) => editProductIngredient(payload),
    {
      onSuccess: (res) => {
        console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(query);
          queryClient.removeQueries({
            queryKey: ["diets"],
            type: "inactive",
          });
          setTitle("");
          setUploadData([]);
          setStatus(1);
          modalClose();
        }
        if (res.status === 400) {
          toast.error(res.message);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );

  useEffect(() => {
    if(details) {
      setTitle(details ? details.title : "");
      setStatus(details ? details.status : "");
      setUploadData(details ? [{ _id: 1, image: details.image }] : []);
      setPublishedData([]);

      setTimeout(() => {
        setPublishedData(
          details
            ? [
              {
                _id: 1,
                label: "Published",
                inputName: "publish_status",
                current: details.status.toString() === 'true' ? true : false,
              },
              {
                _id: 2,
                label: "Draft",
                inputName: "publish_status",
                current: details.status.toString() === 'false' ? true : false,
              },
            ]
            : []
        );
  
      }, 600)
    }
  }, [details]);


  if(isFetching){
    return(
      <div>Loading...</div>
    )
  }

  return (
    <>
      <div className="px-2">
        <div className="row divide-x">
          <div className="col-lg-7">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <Input 
                    state={title}
                    setState={setTitle}
                    label={"Title"} 
                    inputRequired={true} 
                    inputType={"text"} 
                    inputPlaceholder={"Example . Veg"} 
                    inputName={""} 
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <div className="mb-4">
               
                  <RadiosLabel 
                    data={publishedData} 
                    setData={setPublishedData}
                    setRadio={setStatus}
                    label={"Status"} 
                    inputRequired={true} 
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <div className="d-flex flex-wrap gap-3">
                {details ? <Button label={"Save"} 
                  functions={() => handleEdit({
                    id: details._id,
                    type: 3,
                    title: title,
                    status: status === 1 ? true : false,
                    image: uploadData && uploadData[0]?.image.includes('https') ? null : uploadData[0]?.image,
                  })}
                  /> : <Button label={"Save"} 
                  functions={() => handleSubmit({
                    type: 3,
                    title: title,
                    status: status === 1 ? true : false,
                    image: uploadData ? uploadData[0]?.image : null,
                  })}
                  />}
                  <Button label={"Cancel"} classes={"main-button-alt"} functions={() => {
                    modalClose();
                  }}/>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="col">
                <ImageUploadPreview
                  setImage={setUploadData}
                  data={uploadData}
                  label={"Upload Image"}
                  inputRequired={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDiets;
